<!--Grid row-->
<div class="container-fluid" *transloco="let t">
  <div class="row">
    <div class="col">
      <div class="text-center mt-5 pt-5">
        <h1 class="display-3">{{t('home_title')}}</h1>
        <p class="lead w-75 text-center mx-auto mt-3">{{t('home_subtitle')}}</p>
        <button class="btn btn-primary mt-2 mb-3" routerLink="/register">{{t('home_cta')}}</button>

      </div>
      <div class="avatar-container" [@avatarListAnimation]>
        @for (avatar of avatars(); track trackById($index, avatar)) {
          <div
            class="avatar"
            (click)="onAvatarClick(avatar)"
            [style.backgroundImage]="'url(' + avatar.imageUrl + ')'"
            [attr.title]="avatar.name"
          ></div>
        }
      </div>
    </div>
  </div>

  @if (loading) {
    <multisite-loader-globe-animation-detail [width]="100" [height]="100">
    </multisite-loader-globe-animation-detail>
  }

</div>
